<template>
  <div class="top" id="index">
    <img class="bg" src="https://static.worldaic.com.cn/2024/web/static/images/bg.jpg" alt="">
    <!-- <img class="top1" src="https://static.worldaic.com.cn/2024/web/static/images/bg-wap.jpg" alt=""> -->
    <img class="top1" src="@/assets/images/背景2.jpg" alt="">
    <img class="q2" src="https://static.worldaic.com.cn/2024/web/static/images/q2.png" alt="">

    <div class="inner2">
      <!-- <div class="dd d1" @click="linkto1(true, 1, '公告')"> -->
      <div class="dd d1">
        <!-- <img src="https://static.worldaic.com.cn/2024/web/static/images/d1-en.png" v-if="En" alt="">
        <img src="https://static.worldaic.com.cn/2024/web/static/images/d1.png" v-else alt=""> -->
        <img src="@/assets/images/d1-en.png" v-if="En" alt="">
        <img src="@/assets/images/d1.png" v-else alt="">
      </div>
      <div class="dd d2" @click="linkto1('', 2, '论坛')">
        <div v-if="pageTime['首页-头部-论坛']">
          <big :class="`${En}`">{{ En ? pageTime['首页-头部-论坛-en'][0] : pageTime['首页-头部-论坛'][0] }}</big>
          <small><i>{{ En ? pageTime['首页-头部-论坛-en'][1] : pageTime['首页-头部-论坛'][1] }}</i><i>{{ En ? pageTime['首页-头部-论坛-en'][2] : pageTime['首页-头部-论坛'][2] }}</i></small>
        </div>
      </div>
      <div class="dd d3" @click="linkto1('', 3, '展览')">
        <div v-if="pageTime['首页-头部-展览']">
          <big :class="`${En}`">{{ En ? pageTime['首页-头部-展览-en'][0] : pageTime['首页-头部-展览'][0] }}</big>
          <small><i>{{ En ? pageTime['首页-头部-展览-en'][1] : pageTime['首页-头部-展览'][1] }}</i><i>{{ En ? pageTime['首页-头部-展览-en'][2] : pageTime['首页-头部-展览'][2] }}</i></small>
        </div>
      </div>
    </div>

    <div class="top-top">
      <!-- <img class="img3" src="https://static.worldaic.com.cn/2024/web/static/images/t1-wap.png" alt=""> -->


      <img class="cir-img" @mouseenter="stop" @mouseleave="animate" @click="linkto('/zixun', 1, '资讯')" :style="{ width: size(0) * 2 + 'rem', height:  size(0) * 2 + 'rem', left: `calc(${left1} - ${size(0)}rem)`, top: `calc(${top1} - ${size(0)}rem)`, opacity: ((num % 360) > 240) && (num % 360) < 285 ? 0 : 1 }" :src="`https://static.worldaic.com.cn/2024/web/static/images/c1${En}.png`" alt="">

      <img class="cir-img" @mouseenter="stop" @mouseleave="animate" @click="linkto('/profile', 2, '大会')" :style="{ width: size(200) * 2 + 'rem', height:  size(200) * 2 + 'rem', left: `calc(${left2} - ${size(200)}rem)`, top: `calc(${top2} - ${size(200)}rem)`, opacity: ((num % 360) > 40) && (num % 360) < 85 ? 0 : 1 }" :src="`https://static.worldaic.com.cn/2024/web/static/images/c2${En}.png`" alt="">

      <img class="cir-img" @mouseenter="stop" @mouseleave="animate" @click="linkto('/juzheng', 3, '生态')" :style="{ width: size(260) * 2 + 'rem', height:  size(260) * 2 + 'rem', left: `calc(${left3} - ${size(260)}rem)`, top: `calc(${top3} - ${size(260)}rem)`, opacity: ((num % 360) > 340) || (num % 360) < 25 ? 0 : 1 }" :src="`https://static.worldaic.com.cn/2024/web/static/images/c3${En}.png`" alt="">

      <img class="cir-img" @mouseenter="stop" @mouseleave="animate" @click="linkto('/chuangjian', 4, '创见')" :style="{ width: size(120) * 2 + 'rem', height:  size(120) * 2 + 'rem', left: `calc(${left4} - ${size(120)}rem)`, top: `calc(${top4} - ${size(120)}rem)`, opacity: ((num % 360) > 120) && (num % 360) < 165 ? 0 : 1 }" :src="`https://static.worldaic.com.cn/2024/web/static/images/c4${En}.png`" alt="">


      <div class="top-container">
        <!-- <img class="img1" src="https://static.worldaic.com.cn/2024/web/static/images/q1.png" alt=""> -->
        <div class="inner1">
          <div class="liner1-inner" :style="{ transform: `rotate(${num}deg)` }">
            <div class="line line1">
              <!-- <img class="jt" v-for="item in 4" :key="item" v-show="item === current1" :src="require(`https://static.worldaic.com.cn/2024/web/static/images/jt${item}.png`)" alt=""> -->

              <div class="circle" id="wapcircle1">
                
              </div>
            </div>
            <div class="line line2">
              <!-- <img class="jt" v-for="item in 4" :key="item" v-show="item === current2" :src="require(`https://static.worldaic.com.cn/2024/web/static/images/jt${item}.png`)" alt=""> -->

              <div class="circle" id="wapcircle2">
                
              </div>
            </div>
            <div class="line line3">
              <!-- <img class="jt" v-for="item in 4" :key="item" v-show="item === current3" :src="require(`https://static.worldaic.com.cn/2024/web/static/images/jt${item}.png`)" alt=""> -->

              <div class="circle" id="wapcircle3">
                
              </div>
            </div>
            <div class="line line4">
              <!-- <img class="jt" v-for="item in 4" :key="item" v-show="item === current3" :src="require(`https://static.worldaic.com.cn/2024/web/static/images/jt${item}.png`)" alt=""> -->

              <div class="circle" id="wapcircle4">
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <div class="ad">
      <img class="img" src="https://static.worldaic.com.cn/2024/web/static/images/ad.png" @click="showAd(true)" alt=""></img>
      <div class="text">
        {{ $t('notice') }}
      </div>
    </div> -->
    <vloading ref="loading"></vloading>
  </div>
</template>

<script>
import vloading from '@/components/loading.vue'
export default {
  name: 'index',
  components: {
    vloading
  },
  data() {
    return {
      num: 0,
      current1: 1,
      current2: 2,
      current3: 3,
      current4: 4,
      index: 1,
      timer: null,
      meet1: [36, 58, 168, 217, 247, 346],
      meet2: [18, 62, 91, 193, 243, 272],
      meet3: [89, 136, 168, 269, 319, 347],
      left1: '',
      top1: '',
      left2: '',
      top2: '',
      left3: '',
      top3: '',
      left4: '',
      top4: '',
    }
  },
  mounted() {
    this.animate()
  },
  computed: {
    size() {
      return num => {
        num += 270
        const rotate = ((this.num + num) % 360) > 180 ? (360 - (this.num + num) % 360) : ((this.num + num) % 360)
        return (182 - rotate * (100 / 180)) / 200
      }
    },
    opacity() {
      return num => {
        let flag = 1
        this['meet' + num].forEach(x => {
          if (this.num % 360 > (x - 6) && this.num % 360 < (x + 6)) {
            flag = 0
          }
        })
        return flag
      }
    }
  },
  methods: {
    animate() {
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.num += 0.1

        if ($('#wapcircle1') && $('#wapcircle1').offset()) {
          this.left1 = $('#wapcircle1').offset().left + 'px'
          this.top1 = $('#wapcircle1').offset().top + 'px'
        }

        if ($('#wapcircle2') && $('#wapcircle2').offset()) {
          this.left2 = $('#wapcircle2').offset().left + 'px'
          this.top2 = $('#wapcircle2').offset().top + 'px'
        }

        if ($('#wapcircle3') && $('#wapcircle3').offset()) {
          this.left3 = $('#wapcircle3').offset().left + 'px'
          this.top3 = $('#wapcircle3').offset().top + 'px'
        }

        if ($('#wapcircle4') && $('#wapcircle4').offset()) {
          this.left4 = $('#wapcircle4').offset().left + 'px'
          this.top4 = $('#wapcircle4').offset().top + 'px'
        }
      }, 10);
    },
    tun(index, num) {
      this.index = this.current4
      this['current' + index] = this.current4
      this.current4 = num
    },
    stop() {
      if (!this.isPc) return
      clearInterval(this.timer)
    },
    linkto(link, index, name) {
      this.$jsAPI('track','homeClick',
          {
            'floor_var': '首页banner',
            'position_var': index + '',
            'flowName_var': name,
            'industryFirstCate_var': '无',
            'industrySecCate_var': '无',
            'tabName_var': `无`,
          }
      );
      gio('track','homeClick',
          {
            'floor_var': '首页banner',
            'position_var': index + '',
            'flowName_var': name,
            'industryCate_var': '无',
            'industryFirstCate_var': '无',
            'tabName_var': `无`,
          }
      );
      this.animate()
      this.$router.push(link)
    },
    linkto1(link, index, name) {
      this.$jsAPI('track','homeClick',
          {
            'floor_var': '首页banner',
            'position_var': index + '',
            'flowName_var': name,
            'industryFirstCate_var': '无',
            'industrySecCate_var': '无',
            'tabName_var': `无`,
          }
      );
      gio('track','homeClick',
          {
            'floor_var': '首页banner',
            'position_var': index + '',
            'flowName_var': name,
            'industryCate_var': '无',
            'industryFirstCate_var': '无',
            'tabName_var': `无`,
          }
      );
      if (link) {
        this.$refs.loading.getData()
      }
    }
  }
}
</script>

<style lang="less" scoped>
/* 媒体查询（手机） */
@media screen and (max-width: 768px) {
  .top {
    position: relative;
    height: 12.8rem;
    width: 100%;
    background-size: 100% 100%;
    overflow: hidden;

    .ad {
      position: absolute;
      right: .44rem;
      top: 1.86rem;
      width: 1.2rem;
      height: 1.2rem;
      cursor: pointer;

      img {
        display: block;
        width: 100%;
        height: 100%;
      }

      .text {
        position: absolute;
        left: 0;
        right: 0;
        top: .71rem;
        font-size: .18rem;
        line-height: 1;
        color: RGBA(126, 121, 120, 1);
        text-align: center;
        pointer-events: none;
      }
    }

    .top-top {
      position: relative;
      width: 100%;
      height: 16.43rem;
      overflow: hidden;
    }

    .bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      z-index: -3;
    }

    .c4 {
      position: absolute;
      width: 1.78rem;
      height: 1.78rem;
      left: 2.09rem;
      top: 5.92rem;
      cursor: pointer;
      transition: 1s;
      padding: 0.07rem;
    }

    .c4bg {
      position: absolute;
      left: 0;
      top: 0;
      width: 1.68rem;
      height: 1.68rem;
      left: 2.14rem;
      top: 5.97rem;
      pointer-events: none;
      opacity: .8;
    }

    .top1 {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: auto;
      z-index: -2;
    }

    .q2 {
      position: absolute;
      right: .25rem;
      top: 4.09rem;
      width: auto;
      height: 5.16rem;
      z-index: 0;
    }
    .img3 {
      position: absolute;
      left: -1.77rem;
      top: 2.92rem;
      width: 12.27rem;
      height: auto;
      opacity: 0.8;
      z-index: -1;
      pointer-events: none;
    }
    .cir-img {
      position: absolute;
      cursor: pointer;
      z-index: 2;
      transition: opacity 1s;
    }

    .inner2 {
      .dd {
        position: absolute;
        z-index: 10;
        width: 1.4rem;
        height: 1.4rem;
        cursor: pointer;
        transition: 1s;
        background: url("https://static.worldaic.com.cn/2024/web/static/images/ddbg.png");
        background-size: cover;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: hanyi;

        &::before {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          background: url("https://static.worldaic.com.cn/2024/web/static/images/ddbg-circle.png");
          background-size: cover;
          animation: blink 3s infinite;
        }

        big {
          display: block;
          font-size: .29rem;
          font-weight: bold;
          color: #595757;
          line-height: 1;
          text-align: center;

          &.En {
            font-size: .18rem;
          }
        }

        small {
          display: block;
          font-size: .14rem;
          white-space: nowrap;
          color: #595757;
          line-height: 1;
          text-align: center;
          color: rgba(89, 87, 87, .8) !important;

          i {
            display: block;
            font-style: normal;

            &:first-child {
              font-size: .18rem;
              margin: .1rem 0 .05rem;
            }
          }
        }
      }

      .d1 {
        width: 1.08rem;
        height: 1.08rem;
        background: none;
        // left: 1.32rem;
        // top: 9.71rem;
        right: .41rem;
        top: 1.94rem;

        img {
          width: 100%;
          height: 100%;
        }
      }

      .d2 {
        left: .52rem;
        top: 2.84rem;
      }

      .d3 {
        left: 5.26rem;
        top: 9.55rem;

        big, small i {
          // color: rgba(89, 87, 87, .5);
        }
      }
    }

    .top-container {
      margin-left: -1rem;
      margin-top: 2.5rem;
      width: 9.4rem;
      height: 9.4rem;
      transform: rotateX(70deg) rotateY(-27deg);
      transform-origin: left 70%;
      display: flex;
      justify-content: center;
      align-items: center;

      .img1 {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: -1;
      }
    }
    
    .inner1 {
      width: 0;
      height: 0;
      z-index: 4;

      .liner1-inner {
        width: 100%;
        height: 100%;
      }

      .line {
        height: 0;
        width: 4.7rem;
        transform-origin: left top;

        .circle {
          position: absolute;
          left: 100%;
          top: 0;
          width: 0;
          height: 0;

          .cc {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            transform-origin: center center;
            width: 1.88rem;
            height: 1.88rem;
            cursor: pointer;
            transition: 1s;
          }
        }

        .jt {
          position: absolute;
          right: 0;
          top: -25px;
          width: 50px;
          height: auto;
          opacity: 0;
          transition: .2s;
          pointer-events: none;
        }

        &:hover .jt {
          opacity: 1;
          right: 0.9rem;
        }

        &.line1 {
          transform: rotate(0deg);
        }

        &.line2 {
          transform: rotate(200deg);
          .circle {
            .cc {
              width: .90rem;
              height: .90rem;
            }
          }
        }

        &.line3 {
          transform: rotate(260deg);
          .circle {
            .cc {
              width: 1.20rem;
              height: 1.20rem;
            }
          }
        }

        &.line4 {
          transform: rotate(120deg);
          .circle {
            .cc {
              width: 1rem;
              height: 1rem;
            }
          }
        }
      }
    }
  }
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}

</style>



// WEBPACK FOOTER //
// src/pages/home/components/topWap.vue